import React from 'react';
import './../../../../style/Vars.css';
import './../../../../style/ContainersStyles.css';
import './../../../../style/ElementsStyle.css';
import { isMobile, isTablet } from 'react-device-detect';
import { FaUserCircle, FaHome } from 'react-icons/fa';
import CorreoPlantillaCatalog from '../../Components/Catalogos/CorreoPlantilla/CorreoPlantillaCatalog';

export default function CorreoPlantillaPage() {
    const isSmall = isMobile || isTablet;

    return (
        <div className="container-sigma">
            <aside className="sidebar-sigma">
                <div className="sidebar-header-sigma">
                    <FaUserCircle className="user-icon-sigma" />
                    {!isSmall && <span className="user-name-sigma">Administrador</span>}
                </div>
                <nav className="sidebar-nav-sigma">
                    <div className="nav-item-sigma active">
                        <FaHome className="nav-icon-sigma" />
                        {!isSmall && <span className="nav-text-sigma">Plantillas Correo</span>}
                    </div>
                </nav>
            </aside>

            <CorreoPlantillaCatalog />
        </div>
    );
}
